export const RefrigeratorIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="29"
    height="56"
    viewBox="0 0 29 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.6984 0.600098H2.52272C1.46089 0.600098 0.600098 1.46088 0.600098 2.52271V50.9774C0.600098 52.0392 1.46089 52.9 2.52272 52.9H25.6984C26.7602 52.9 27.6209 52.0392 27.6209 50.9774V2.52271C27.6209 1.46088 26.7602 0.600098 25.6984 0.600098Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6209 16.6484H0.600098"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6209 49.7119H0.600098"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.29688 6.14893H5.32119C5.56456 6.14893 5.76274 6.3471 5.76274 6.59047V12.6712C5.76274 12.9146 5.56456 13.1127 5.32119 13.1127H5.29688"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.29688 20.1809H5.32119C5.56456 20.1809 5.76274 20.3791 5.76274 20.6224V26.7032C5.76274 26.9466 5.56456 27.1447 5.32119 27.1447H5.29688"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25879 52.9001V54.2039C5.25879 54.4229 5.43611 54.6003 5.65514 54.6003H7.90455C8.12358 54.6003 8.3009 54.4229 8.3009 54.2039V52.9001"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9233 52.9001V54.2039C19.9233 54.4229 20.1007 54.6003 20.3197 54.6003H22.5691C22.7882 54.6003 22.9654 54.4229 22.9654 54.2039V52.9001"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
